/**
 * index.js contains the logic to expose the component, in this case it simply exposes
 * the PrimaryNavBar.component, in some complex cases this might contain the logic to
 * expose the components condtionally.
 */
import PrimaryNavBar from './PrimaryNavBar.component';

export default PrimaryNavBar;
